<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="slide-in">
            <Breadcrumb
                name="Volume Reports"
                bc1="App"
                bc2="Reports"
                bc3="Volume"
                path="volume-reports"
            />
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card gradient-card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-12 user_plan">
              <div class="form-group">
                <label>Select Merchant</label>
                <div class="input-group">
                  <SearchSelectMultipleWithState
                      v-model="selectedMerchant"
                      url="v1/get-merchants"
                      :filterParams="{ flag: 'all' }"
                      :customLabelFn="customNameForMultiselect"
                      placeholder="Search Merchant..."
                      :multiple="true"
                  />
                </div>
              </div>
            </div>
          </div>
<!--          <div class="d-flex align-items-center mx-50 row pt-0 pb-2" v-if="selectedMerchant && selectedMerchant.length === 1">-->
<!--            <div class="col-md-6 user_plan">-->
<!--              <div class="form-group">-->
<!--                <label>Select Account</label>-->
<!--                <div class="input-group">-->
<!--                  <select-->
<!--                      class="form-control"-->
<!--                      v-model="selectedMerchantDetails"-->
<!--                  >-->
<!--                    <option-->
<!--                        :key="merchantDetailsIndex"-->
<!--                        :value="merchantDetails"-->
<!--                        v-for="(merchantDetails, merchantDetailsIndex) in MerchantDetailsData"-->
<!--                    >-->
<!--                      {{ merchantDetails.account_title + ' / ' + merchantDetails.currency.code }}-->
<!--                    </option>-->
<!--                  </select>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <div class="form-group">
                <label>Select Store</label>
                <InfiniteSelect
                    api-url="v1/get-store"
                    ref="storeInfiniteSelect"
                    :request-params="requestParams"
                    :formatter="customStoreNameForMultiselect"
                    key-field="id"
                    @selectedFullObj="handleStoreSelected"
                    placeholder-text="Select a store..."
                />
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group">
                <label>Select Terminal</label>
                <div class="input-group input-group input-group-merge">
                  <multiselect
                      v-model="selectedTerminal"
                      :options="terminalData"
                      label="label"
                      track-by="id"
                      placeholder="Select Terminal"
                      :loading="terminalLoader"
                      :custom-label="customStoreNameForMultiselect"
                  ></multiselect>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group">
                <label>Select Channel</label>
                <div class="input-group input-group input-group-merge">
                  <multiselect
                      v-model="selectedChannel"
                      :options="channelData"
                      label="label"
                      track-by="id"
                      placeholder="Select Channel"
                      :loading="channelLoader"
                      :custom-label="customStoreNameForMultiselect"
                  ></multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <div style="height: 24px;">
                <label>Year Range</label>
              </div>
              <RangeSlider v-model="yearRange" :min="yearMin" :max="yearMax" />
            </div>
            <div class="col-md-4 user_plan" v-if="showMonthFilterToggle">
              <div style="height: 24px;">
                <div class="custom-control custom-switch mb-1">
                  <input id="monthFilterToggle" type="checkbox" v-model="enableMonthFilter" class="custom-control-input" />
                  <label class="custom-control-label" for="monthFilterToggle">
                    Month Range
                  </label>
                </div>
              </div>
              <RangeSlider v-if="enableMonthFilter" v-model="monthRange" :min="1" :max="12" :formatValue="formatMonthValue" />
              <div v-else style="height: 80px;"></div>
            </div>
            <div class="col-md-4 user_plan" v-if="showDayFilterToggle">
              <div style="height: 24px;">
                <div class="custom-control custom-switch mb-1">
                  <input id="dayFilterToggle" type="checkbox" v-model="enableDayFilter" class="custom-control-input" />
                  <label class="custom-control-label" for="dayFilterToggle">
                    Day Range
                  </label>
                </div>
              </div>
              <RangeSlider v-if="enableDayFilter" v-model="dayRange" :min="1" :max="31" />
              <div v-else style="height: 80px;"></div>
            </div>
          </div>
          <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-3 mb-2">
            <!-- Generate – primary action -->
            <button type="button" class="btn btn-primary btn-sm" @click="onSubmitFilters">
              <feather type="play" class="me-25" size="16"></feather> Generate
            </button>

            <!-- Download PDF – secondary action -->
            <button type="button" class="btn btn-outline-danger ml-1 btn-sm" @click="onDownload('pdf')">
              <feather type="download" class="me-25" size="16"></feather> Download PDF
            </button>

            <!-- Download Excel – secondary action -->
            <button type="button" class="btn btn-outline-success ml-1 btn-sm" @click="onDownload('excel')">
              <feather type="download" class="me-25" size="16"></feather> Download Excel
            </button>

            <!-- Clear – subtle action -->
            <button type="button" class="btn btn-secondary ml-1 btn-sm" @click="onClearFilters">
              <feather type="refresh-ccw" class="me-25" size="16"></feather> Clear
            </button>
          </div>
        </div>
        <div class="card" v-show="showTable">
          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :filteredData="filteredData"
              :loadMore="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchSelectMultipleWithState from "@/components/common/SearchSelectMultipleWithState.vue";
import RangeSlider from "@/components/common/RangeSlider.vue";
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";
import SelectOptions from "@/components/common/SelectOptions.vue";

export default {
  components: {
    SearchSelectMultipleWithState,
    RangeSlider,
    InfiniteSelect,
    SelectOptions
  },
  mounted(){
    this.showSelectAccountOption = 'v1/get-wallet-list'
    const currentYear = new Date().getFullYear()
    this.yearMin = currentYear - 6
    this.yearMax = currentYear
    this.yearRange = [currentYear, currentYear]
  },
  data(){
    return{
      selectedMerchant: [],
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      MerchantDetailsData: [],
      terminalLoader:false,
      channelLoader:false,
      showSelectAccountOption: '',
      selectedMerchantDetails: null,
      filteredData:{},
      showTable: false,
      requestParams: {},
      url: "v1/get-merchant-volume",
      storageKey: "volume-reports",
      actions: [],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      
      // Date range filters with sliders
      yearRange: [],
      yearMin: null,
      yearMax: null,
      monthRange: [1, 12],
      dayRange: [1, 31],
      enableMonthFilter: false,
      enableDayFilter: false,

      tableHeaderValues: [
        {
          title: 'Merchant Name',
          valueKey: 'merchantName',
        },
        {
          title: 'Year',
          valueKey: 'year',
        },
        {
          title: 'Month',
          valueKey: 'month',
          html: true,
          alter: (value) => {
            if(value === undefined || value === null || value === ''){
              return '-'
            }
            return this.getMonthName(value) || '-'
          }
        },
        {
          title: 'Day',
          valueKey: 'day',
        },
        {
          title: 'Amount',
          valueKey: 'totalAmount',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<div class="font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div>`
            else
              html = '-'
            return html
          }
        },
        {
          title: 'Fee',
          valueKey: 'fee',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<div class="font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div>`
            else
              html = '-'
            return html
          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<div class="font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div>`
            else
              html = '-'
            return html
          }
        },
      ],
    }
  },
  methods:{
    handleStoreSelected(item) {
      this.selectedStore = item
      if(item){
        this.terminalData = item.terminals || []
      }else{
        this.terminalData = []
      }
    },
    customNameForMultiselect({ email, first_name, business_name }) {
      const nameToUse = business_name === null || business_name === '' ? first_name : business_name;
      return `${email}/${nameToUse}`;
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    // getMerchantDetailsData(id) {
    //   this.makeRequest("post", "v1/detail-merchant", {id: id}, {}, false,true,[205]).then(
    //       (callResponse) => {
    //         if (!callResponse.error) {
    //           let code = callResponse.response.data.code;
    //           let responseData = callResponse.response.data.data;
    //           if (code == 200) {
    //             this.MerchantDetailsData = responseData.accounts ? responseData.accounts : [];
    //             this.setSelectedMerchantDetailsValue();
    //           }
    //         }
    //       }
    //   );
    // },
    // setSelectedMerchantDetailsValue() {
    //   this.selectedMerchantDetails = this.MerchantDetailsData[0];
    // },
    getTerminalData() {
      if(!this.selectedMerchant || !this.selectedStore){
        return
      }
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {userId: this.selectedMerchant.id,storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
              }
            }
            this.terminalLoader = false
          }
      );
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {userId: this.selectedMerchant.id,storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
              }
            }
            this.channelLoader = false
          }
      );
    },
    getMonthName(monthNumber) {
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]
      return months[monthNumber - 1] || monthNumber
    },
    formatMonthValue(value) {
      return this.getMonthName(value)
    },
    onSubmitFilters() {
      // Validate account selection (only required if exactly one merchant is selected)
      // if(this.selectedMerchant && this.selectedMerchant.length === 1 && !this.selectedMerchantDetails){
      //   this.$toast.error('Please select an account', {
      //     position: "top-center",
      //     timeout: 2000,
      //     closeOnClick: true,
      //   })
      //   return
      // }


      let dataFiltered = {}

      if(this.selectedMerchant && this.selectedMerchant.length > 0){
        dataFiltered.userIds = JSON.stringify(this.selectedMerchant.map(m => m.id))
      }

      if(this.selectedStore){
        dataFiltered.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.channelId = this.selectedChannel.id
      }

      // Only send userAccountId if exactly one merchant is selected
      if(this.selectedMerchant && this.selectedMerchant.length === 1 && this.selectedMerchantDetails){
        dataFiltered.userAccountId = this.selectedMerchantDetails.id
      }

      if(this.yearRange && this.yearRange.length === 2){
        dataFiltered.fromYear = Math.min(this.yearRange[0], this.yearRange[1])
        dataFiltered.toYear = Math.max(this.yearRange[0], this.yearRange[1])

        // Only add month filter if years are the same and toggle is enabled
        if(dataFiltered.fromYear === dataFiltered.toYear && this.enableMonthFilter){
          if(this.monthRange && this.monthRange.length === 2){
            dataFiltered.fromMonth = Math.min(this.monthRange[0], this.monthRange[1])
            dataFiltered.toMonth = Math.max(this.monthRange[0], this.monthRange[1])

            // Only add day filter if months are the same and toggle is enabled
            if(dataFiltered.fromMonth === dataFiltered.toMonth && this.enableDayFilter){
              if(this.dayRange && this.dayRange.length === 2){
                dataFiltered.fromDay = Math.min(this.dayRange[0], this.dayRange[1])
                dataFiltered.toDay = Math.max(this.dayRange[0], this.dayRange[1])
              }
            }
          }
        }
      }

      this.filteredData = {...dataFiltered}
      this.$nextTick(() => {
        this.showTable = true
      })
    },
    onClearFilters() {
      this.selectedMerchant = null
      this.selectedMerchantDetails = null
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.MerchantDetailsData = []
      const currentYear = new Date().getFullYear()
      this.yearRange = [currentYear, currentYear]
      this.monthRange = [1, 12]
      this.dayRange = [1, 31]
      this.enableMonthFilter = false
      this.enableDayFilter = false
      this.filteredData = {}
      this.showTable = false
      if(this.$refs.storeInfiniteSelect){
        this.$refs.storeInfiniteSelect.reset()
      }
    },
    onDownload(format) {
      // Validate account selection (only required if exactly one merchant is selected)
      // if(this.selectedMerchant && this.selectedMerchant.length === 1 && !this.selectedMerchantDetails){
      //   this.$toast.error('Please select an account', {
      //     position: "top-center",
      //     timeout: 2000,
      //     closeOnClick: true,
      //   })
      //   return
      // }

      this.onSubmitFilters()

      let requestData = {
        exportAs: 'excel',
        reportType: 'volume',
        download:format,
        ...this.filteredData
      }

      this.downloadReport(requestData, 'v1/get-merchant-volume')
    },
  },
  computed: {
    showMonthFilterToggle() {
      // Show month filter toggle only if start and end year are the same
      if(this.yearRange && this.yearRange.length === 2){
        return Math.min(this.yearRange[0], this.yearRange[1]) === Math.max(this.yearRange[0], this.yearRange[1])
      }
      return false
    },
    showDayFilterToggle() {
      // Show day filter toggle only if start and end month are the same (and years are same)
      if(this.showMonthFilterToggle && this.monthRange && this.monthRange.length === 2){
        return Math.min(this.monthRange[0], this.monthRange[1]) === Math.max(this.monthRange[0], this.monthRange[1])
      }
      return false
    }
  },
  watch:{
    selectedMerchant(val) {
      this.selectedStore = null
      this.selectedMerchantDetails = null
      this.MerchantDetailsData = []
      this.requestParams = null
      // if(val && val.length === 1){
      //   this.getMerchantDetailsData(val[0].id)
      //   this.requestParams = JSON.parse(JSON.stringify({userId: val[0].id}))
      // }else{
      //   this.selectedStore = null
      //   this.selectedMerchantDetails = null
      //   this.MerchantDetailsData = []
      //   this.requestParams = null
      // }
    },
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
}
</script>

<style scoped>
.slide-in {
  animation: slideIn 0.6s ease-out;
}
@keyframes slideIn {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}
.gradient-card {
  background: linear-gradient(135deg, #f5faff 0%, #dde9f5 100%);
  border: none;
  box-shadow: 0 4px 20px rgba(42, 112, 154, 0.10);
  transition: box-shadow 0.3s ease, transform 0.2s ease;
}
.gradient-card:hover {
  box-shadow: 0 8px 30px rgba(42, 112, 154, 0.18);
  transform: translateY(-2px);
}
</style>
